/**
 * Component for searching in a Knowledge Base.
 *
 * @module
 */
import * as React from 'react';
import { useSearch } from '../hooks';
import { LoopResults, IsEmpty, IsNotEmpty } from './searchResults';
export { LoopResults, IsEmpty, IsNotEmpty };
/**
 * Component for searching in a Knowledge Base.
 *
 * Utilises [[useSearch]] under the hood.
 *
 * Usage example:
 * ```javascript
 * import Search from '@elevio/kb-kit/lib/components/search';
 *
 * export const MySearchComponent: React.FC = () => {
 *   return (
 *     <div>
 *       <section>Search here for content:</section>
 *       <Search.Input />
 *     </div>
 *   );
 * };
 * ```
 */
export const Input = ({ ...rest }) => {
    const { value, onChange, onKeyUp, onOpenDropdown } = useSearch();
    return (React.createElement("input", { ...rest, type: rest.type || 'search', value: value, onKeyUp: onKeyUp, onChange: onChange, onFocus: onOpenDropdown, "data-testid": "search-input" }));
};
Input.displayName = 'Search.Input';
//# sourceMappingURL=search.js.map